import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { regPopupTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import Chart from 'chart.js/auto';
//import { saveAs } from 'file-saver';

import { Sesion, Datos, Layers } from '../main.js';
import { Mimapa } from './map.js';
import { getGrid } from './grid.js';
import { downloadPolygonPlots } from './dataManager.js';
import { parcelasSP, cambiarSeleccionRegionSP } from './plots.js';
import { getLiteral, getDate, uriToLiteral, firstUppercase, getPreferredLang } from './util.js';
import { initTimedEvent } from './events.js';


// aquí guardo las features de las provincias y municipios (ver cargarProvincias)
let featprovs;
let featmunis;
let provspintadas = false;
let munispintados = {};

function inicializarRegiones() {
	// devuelvo la capa GEOJSON para las provincias
	return L.geoJson(null, {
		style: estiloRegion,
		onEachFeature: enCadaRegion
	}).addTo(Mimapa);
}

function cargarRegiones() {
	// preparo los datos en GeoJSON de las provincias
	featprovs = [];
	const pruris = Object.keys(Datos.provs);
	for (let pruri of pruris) {
		let prov = Datos.provs[pruri];
		let prdata = {
			"type": "Feature",
			"properties" : {}
		};
		// sólo incluyo la provincia si hay geometría
		if (prov.geometry) {
			prdata.geometry = prov.geometry;
			prdata.properties = prov;
			// borro redundancia geometrías en properties
			delete prdata.properties.geometry;				
			featprovs.push(prdata);				
		}		
	}
	// preparo los datos en GeoJSON de los municipios
	featmunis = [];
	const muris = Object.keys(Datos.munis);
	for (let muri of muris) {
		let muni = Datos.munis[muri];
		let mdata = {
			"type": "Feature",
			"properties" : {}
		};
		// sólo incluyo el municipio si hay geometría
		if (muni.geometry) {
			mdata.geometry = muni.geometry;
			mdata.properties = muni;
			// borro redundancia geometrías en properties
			delete mdata.properties.geometry;				
			featmunis.push(mdata);				
		}		
	}
	// llamo a repintar
	repintarRegiones();
	
	
	// descarga GeoJSONs (quitar)
	/*
	const objprovs = {
		"type": "FeatureCollection",
		"features": featprovs
	};
	const blobprovs =  new Blob([JSON.stringify(objprovs, null, 2)], {type: "text/plain;charset=utf-8"});
	saveAs(blobprovs, "provs_simp.json");
	const objmunis = {
		"type": "FeatureCollection",
		"features": featmunis
	};	
	const blobmunis =  new Blob([JSON.stringify(objmunis, null, 2)], {type: "text/plain;charset=utf-8"});
	saveAs(blobmunis, "munis.json");*/
}

function pintarRegiones(provs) {
	if (provs) {
		if (!provspintadas) {			
			console.time("pintado provs");
					
			// pinto las provincias
			Layers.regs.addData(featprovs);
			
			// pongo sus popups
			ajustarPopupsRegiones();
			
			// pongo arriba los municipios seleccionados 
			for (const miri in Sesion.estado.SP.munis) {
				const mlayer = Layers.regs.getLayers().find(layer => layer.feature.properties.iri === miri);
				mlayer.bringToFront();
			}
			
			// pongo arriba los polígonos
			Layers.polis.getLayers().forEach(layer => layer.bringToFront());	
				
			// y más arriba las parcelas
			Layers.parcs.getLayers().forEach(layer => layer.bringToFront());
			
			// marco
			provspintadas = true;
			
			console.timeEnd("pintado provs");
		}
	}
	else {
		//  extraigo los municipios de la parte visible del mapa	
		const bounds = Mimapa.getBounds();
		//console.log("#munis: " + Object.keys(Datos.munis).length);
		const miris = Object.keys(Datos.munis).filter(miri => {
			return Datos.munis[miri].south <= bounds._northEast.lat &&
				Datos.munis[miri].north >= bounds._southWest.lat &&
				Datos.munis[miri].west <= bounds._northEast.lng &&
				Datos.munis[miri].east >= bounds._southWest.lng;		
		});
	
		// borro los municipios no pedidos que no estén seleccionados
		console.time("borrado munis");
		
		// detecto los municipios a borrar: pintados, pero no en miris ni en los seleccionados
		const borrar = Object.keys(munispintados).filter((miri) => !miris.includes(miri) && !Sesion.estado.SP.munis[miri]);
		console.log("#munis borrar: " + borrar.length);
		// borro
		for (const miri of borrar) {
			Layers.parcs.removeLayer(munispintados[miri]);
			delete munispintados[miri];	
		}			
		console.timeEnd("borrado munis");
		
		// pinto los municipios pedidos
		console.time("pintado munis");
		
		// pinto los municipios uno a uno
		const nuevos = [];
		for (const miri of miris) {
			if (!munispintados[miri]) {
				const featm = featmunis.find(fm => fm.properties.iri === miri);
				munispintados[miri] = Layers.regs.addData(featm);
				nuevos.push(miri);
			}
		}		
		console.log("#munis pintados: " + nuevos.length);
		// pongo sus popups
		ajustarPopupsRegiones(null, true);		
		
		// esta capa abajo (no me sirve porque me desordena las cosas de la capa)
		//Layers.regs.bringToBack();
		
		// pongo arriba las regiones seleccionadas (empezando por las provincias)
		for (const priri in Sesion.estado.SP.provs) {
			const prlayer = Layers.regs.getLayers().find(layer => layer.feature.properties.iri === priri);
			prlayer.bringToFront();
		}
		for (const miri in Sesion.estado.SP.munis) {
			const mlayer = Layers.regs.getLayers().find(layer => layer.feature.properties.iri === miri);
			mlayer.bringToFront();
		}
		
		// pongo arriba los polígonos
		Layers.polis.getLayers().forEach(layer => layer.bringToFront());
		
		// y más arriba las parcelas
		Layers.parcs.getLayers().forEach(layer => layer.bringToFront());
		
		console.timeEnd("pintado munis");
	}
}


function repintarRegiones() {
	// borro la capa	
	Layers.regs.clearLayers();
	// nada pintado
	provspintadas = false;
	munispintados = {};
	// pinto las provincias seleccionadas
	for (const priri in Sesion.estado.SP.provs) {
		// recupero y cargo
		const featpr = featprovs.find(feat => feat.properties.iri === priri);
		Layers.regs.addData(featpr);
	}
	// pinto los municipios seleccionados
	for (const miri in Sesion.estado.SP.munis) {
		// recupero y cargo
		const featm = featmunis.find(feat => feat.properties.iri === miri);
		munispintados[miri] = Layers.regs.addData(featm);
	}
	// llamo a pintar
	pintarRegiones(Sesion.estado.mapDetails === config.mapConfig.mapDetails[1]);
}

function colorRegion(sel, esBorde) {
	const indcol = sel? config.colregselind : config.colregind;
	const indgrado = esBorde? 4 : 2;
	return config.colores[indcol][indgrado];
}


function ajustarColorRegiones(riris) {
	// si no hay riris, reajusto el estilo a todas las layers
	if (!riris) 
		Object.values(Layers.regs._layers).forEach(layer => layer.setStyle( estiloReg(layer.feature.properties.iri) ));
	else {
		for (let riri of riris) {
			const layer = Object.values(Layers.regs._layers).find(layer => layer.feature.properties.iri === riri);
			// reajusto estilo
			layer.setStyle( estiloReg(riri) );
		}
	}
}


// ESTILOS REGIONES
// preparo estilo polígonos
function estiloRegion(reg) {
	return estiloReg(reg.properties.iri);
}
function estiloReg(riri) {
	const rsel = Sesion.estado.SP.provs[riri] != undefined || Sesion.estado.SP.munis[riri] != undefined;
	const sat = Sesion.estado.mapType === config.mapConfig.mapType[1]; // capa satélite
	return {
		fillColor: colorRegion(rsel, false), // color de relleno  
		weight: rsel? 2 : 1.5,
		opacity: 1,
		color: colorRegion(rsel, true),
		dashArray: '1',
		fillOpacity: (sat && !rsel)? 0.1 : 0.6
	};
}
function realceRegion(e) {
	const layer = e.target;
	const rsel = Sesion.estado.SP.provs[layer.feature.properties.iri] != undefined 
		|| Sesion.estado.SP.munis[layer.feature.properties.iri] != undefined;
	if (rsel || Sesion.zoom > config.zRealceMax[Sesion.estado.mapDetails])
		return; // no hay realce cuando ya seleccionada o el zoom es muy grande
	const sat = Sesion.estado.mapType === config.mapConfig.mapType[1]; // capa satélite
	//const indcol = prsel? config.colprovselind : config.colprovind;
	layer.setStyle({
		fillColor: sat? config.colores[config.colregind][2] : config.colores[config.colregind][3],
		weight: 2,
		dashArray: '',
		fillOpacity: sat? 0.3 : 0.6
	});
}
function quitarRealceRegion(e) {
    const layer = e.target;
    if (e.type === "popupclose" || !(layer.getPopup() && layer.getPopup().isOpen()))
	    Layers.regs.resetStyle(layer);
}
function enCadaRegion(feature, layer) {
	// eventos popup, realce y selección (doble click)	
	layer.on({
		popupopen: realceRegion,
		popupclose: quitarRealceRegion,
		mouseover: realceRegion,
		mouseout: quitarRealceRegion,
		dblclick: function(e) {
			L.DomEvent.stopPropagation(e); // para que el mapa no haga doubleClickZoom				
			selRegion(e.target.feature.properties.iri);
		} 
	});
}

async function selRegion(riri) {
	// extraigo region
	let tiporeg = 'municipality';
	let reg = Datos.munis[riri];
	if (!reg) {
		tiporeg = 'province';
		reg = Datos.provs[riri];
	}
	
	// inicializo TimedEvent GA (sólo se empleará si la provincia se selecciona, si se deselecciona no se mide el tiempo )
	initTimedEvent({
		content_type: tiporeg,
		content_id: getLiteral(reg.label)
	});
	
	// puede que no esté pintada (si es un municipio y están seleccionadas las provincias), me aseguro;
	let rlayer = Layers.regs.getLayers().find(layer => layer.feature.properties.iri === riri);
	if (!rlayer) {
		// recupero el feature adecuado
		const featregs = tiporeg === 'municipality'? featmunis : featprovs;
		const featreg = featregs.find(feat => feat.properties.iri === riri);
		// lo cargo
		const rpint = Layers.regs.addData(featreg);
		if (tiporeg === 'municipality')		
			munispintados[riri] = rpint;
		// y recupero la referencia
		rlayer = Layers.regs.getLayers().find(layer => layer.feature.properties.iri === riri);
	}

	// miro si ya tengo las parcelas de la región
	if (!reg.plots) {
		// extracción de datos	
		
		// inicializo temporizador
		console.time("Descarga parcelas " + getLiteral(reg.label));
		
		// obtengo datos del feature
		const feat = {
			type: tiporeg,
			iri: riri,
			bounds:  rlayer._bounds,
			feature: rlayer.feature, 
			labprog: '<i>' + getLiteral(dict.downloading) + " " + getLiteral(reg.label) + '...</i>'
		}
		
		// pido datos y guardo
		reg.plots = await downloadPolygonPlots(feat);
		
		// fin temporizador
		console.timeEnd("Descarga parcelas " + getLiteral(reg.label));
	}
	
	// actualizo selección
	cambiarSeleccionRegionSP(riri);
}


function ajustarPopupsRegiones(riris, notocarpopupabierto) {
	// si no hay riris, reajusto el popup de todas las layers
	if (!riris) {		
		Object.values(Layers.regs._layers).forEach(layer => {
			// reajusto popup
			const op = popupRegion(layer.feature.properties.iri); // obtengo el popup			
			layer.bindPopup(op.popup, op.opcs);
		});
	}
	else {		
		for (const riri of riris) {
			const layer = Object.values(Layers.regs._layers).find(layer => layer.feature.properties.iri === riri);	
			// reajusto popup
			if (layer) {
				const op = popupRegion(riri); // obtengo el popup			
				layer.bindPopup(op.popup, op.opcs);
			}
		}
	}
	if (notocarpopupabierto) return; // para no enredar más
	// si hay un popup abierto miro si hay que actualizarlo
	if (Sesion.popup && Sesion.popup.isOpen()) {
		// cojo la IRI del popup
		// cojo el DOM element del popup
		const popel = Sesion.popup.getElement();
		// cojo el DOM element de la clase popup
		const popupel = popel.querySelector(".popup");
		// si es de tipo reg entonces miro si hay que repintar el popup
		if (popupel && popupel.classList.contains("reg")) {
			// extraigo la iri
			const riri = popel.querySelector(".popup").getAttribute("iri");
			// si está contenida en riris, entonces repinto el popup
			if (!riris || riris.includes(riri)) {
				// extraigo coords del popup
				const latlng = Sesion.popup.getLatLng();				
				Mimapa.closePopup();
				// recupero el layer de la región
				const layer = Object.values(Layers.regs._layers).find(layer => layer.feature.properties.iri === riri);
				// reabro el popup en las coords anteriores
				layer.openPopup(latlng);
			}
		}
	}
}

function popupRegion(riri) {
	// extraigo la región
	const reg = Datos.provs[riri]? Datos.provs[riri] : Datos.munis[riri];
	const spreg = Datos.provs[riri]? Sesion.estado.SP.provs[riri] : Sesion.estado.SP.munis[riri];

	// devuelvo un objeto con el popup y las opciones de rendering
	const out = {
		popup: {},
		opcs: {} // caso sin canvas
	};
	// preparo plantilla para el mustache
	const rtemp = {};
	// iri
	rtemp.iri = riri;
	rtemp.reg = getLiteral(reg.label); // etiqueta con el nombre
	// infoprov
	if (reg.province)
		rtemp.infoprov = getLiteral(dict.provinceof) + getLiteral(Datos.provs[reg.province].label);
	// fuente
	rtemp.source = getLiteral(dict["source" + Sesion.estado.ifn]);
	// dataCapture
	if (reg[Sesion.estado.ifn] && reg[Sesion.estado.ifn].begins && reg[Sesion.estado.ifn].ends) {
		rtemp.dataCapture = getLiteral(dict.dataCaptureFrom) + getDate(reg[Sesion.estado.ifn].begins)
				+ getLiteral(dict.dataCaptureTo) + getDate(reg[Sesion.estado.ifn].ends);
	}
	// sampledplots (los extraídos del polígono o los asignados en el triplestore)
	let nsp = 0;
	if (!reg[Sesion.estado.ifn])
		rtemp.noplots = true;
		//rtemp.sampledplots = getLiteral(dict.nosampledplots);
	else {
		nsp = reg.plots? reg.plots[Sesion.estado.ifn].length
			: reg[Sesion.estado.ifn].nallplots;
		if (!nsp || nsp == 0) {
			nsp = 0;
			rtemp.noplots = true;
		}
		else if (nsp == 1)
			rtemp.sampledplots = getLiteral(dict.sampledplot);
		else
			rtemp.sampledplots = nsp + getLiteral(dict.sampledplots);
	}	
	// extraigo status y ajusto botones
	if (spreg) {
		if (nsp > 0) {
			rtemp.chart = true;
			out.opcs = {minWidth: 360};
		}
		rtemp.status = rtemp.reg + getLiteral(dict.isSelected); // seleccionada
		rtemp.statusClass = "text-warning";
		rtemp.selected = true; // habilito botón de deseleccionar
	}
	else {
		rtemp.status = rtemp.reg + getLiteral(dict.isUnselected); // no seleccionada
		rtemp.statusClass = "text-secondary";
		rtemp.unselected = true; // habilito botón de seleccionar
	}	
	// obtengo el popup y lo devuelvo
	out.popup = Mustache.render(regPopupTemplate, rtemp);
	
	return out;
}

function ponerChartPopupRegion(canvas, riri) {	
	// extraigo estadísticos de la región
	const statsreg = Datos.provs[riri]? Datos.statsProvs[riri] : Datos.statsMunis[riri];

	// muestro el canvas
	canvas.classList.remove("d-none");
	
	// preparo los datos del chart
	const labels = [];
	const valores = [];
	const colores = [];
	// sólo habrá datos en Datos.statsProvs o Datos.statsMunis si la región está seleccionada
	if (statsreg) {
		// manual
		if (statsreg[Sesion.estado.ifn].manual > 0) {
			labels.push(getLiteral(dict.manuallySelected));
			valores.push(statsreg[Sesion.estado.ifn].manual);
			colores.push(config.colores[config.colregselind][8]);
		}
		// seleccionadas 
		const nsel = statsreg[Sesion.estado.ifn].total 
			- statsreg[Sesion.estado.ifn].manual	
			- statsreg[Sesion.estado.ifn].filt
			- statsreg[Sesion.estado.ifn].bloq;
		if (nsel > 0) {
			labels.push(getLiteral(dict.selected));
			valores.push(nsel);
			colores.push(config.colores[config.colregselind][3]);
		}
		// filtered
		if (statsreg[Sesion.estado.ifn].filt > 0) {
			labels.push(getLiteral(dict.filtered));
			valores.push(statsreg[Sesion.estado.ifn].filt);
			colores.push(config.colores[config.colplotind][4]);
		}
		// blocked
		if (statsreg[Sesion.estado.ifn].bloq > 0) {
			labels.push(getLiteral(dict.blocked));
			valores.push(statsreg[Sesion.estado.ifn].bloq);
			colores.push(config.colblack);
		}
	}
	/* estos datos puede que no los tenga y no merece la pena cargarlos (así que sin gráfica si no seleccionada)	
	else { // en este caso hay que conseguir las estadísticas analizando las parcelas
		const ntot = Datos.provs[priri].plots[Sesion.estado.ifn].length;
		let nman = 0;
		let nbloq = 0;
		let nsel = 0; // sin contar las manuales
		for (const piri of Datos.provs[priri].plots[Sesion.estado.ifn]) {
			if (Sesion.estado.SP[Sesion.estado.ifn].manual[piri])
				nman++;
			else if (Sesion.estado.SP[Sesion.estado.ifn].bloq[piri])
				nbloq++;
			else if (parcelasSP[Sesion.estado.ifn].has(piri))
				nsel++;
		}
		// manual
		if (nman > 0) {
			labels.push(getLiteral(dict.manuallySelected));
			valores.push(Datos.statsProvs[priri][Sesion.estado.ifn].manual);
			colores.push(config.colores[config.colprovselind][7]);
		}
		// seleccionadas (por polígonos)
		if (nsel > 0) {
			labels.push(getLiteral(dict.selected));
			valores.push(nsel);
			colores.push(config.colores[config.colprovselind][4]);
		}		
		// disponibles
		const ndisp = ntot - nman - nbloq - nsel;
		if (ndisp > 0) {
			labels.push(getLiteral(dict.available));
			valores.push(nsel);
			colores.push(config.colores[config.colplotind][4]);	
		}
		// blocked
		if (nbloq > 0) {
			labels.push(getLiteral(dict.blocked));
			valores.push(nbloq);
			colores.push(config.colblack);
		}	
	}*/	
	// preparo el chart
	const chartconfig =  {
		type: 'doughnut',
		data: {
			labels: labels,
			datasets: [{
				label: getLiteral(dict.nplots),
				data: valores,
				backgroundColor: colores,
				hoverOffset: 4
			}]
		},
		options: {
			animation: false
		}
	};	
	// pinto
	new Chart(canvas, chartconfig);	
}


export { inicializarRegiones, cargarRegiones, repintarRegiones, pintarRegiones, selRegion, ajustarColorRegiones,
	ajustarPopupsRegiones, ponerChartPopupRegion };